
let LOGIN_TYPES = {
    UN_VALIDATE:'UN_VALIDATE',
    LOGIN_ED:'LOGIN_ED',
    UN_LOGIN:'UN_LOGIN'
}
export default LOGIN_TYPES;